module.exports = __webpack_public_path__ + "media/images/lb/063-674eecdf56acc083573c80053d365ed8.svg";